import { useState, useEffect } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import { FaChevronLeft } from "react-icons/fa6";
import { Link, useParams, useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import Footer from "./Footer/Footer";
import { ethers } from "ethers";
import { BrowserProvider } from "ethers";
import TokenSaleAbi from "./abi/TokenSale.json";
import BEP20_ABI from "./abi/ERC20.json";
import useLiveStockPrice from "./useLiveStockPrice";

import {
  useWeb3Modal,
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from "@web3modal/ethers/react";
import { toast } from "react-toastify";

// Import your API service
import apiService from "../core/Service/detail";
import { postMethod } from "../core/service/common.api";
import { Oval } from "react-loader-spinner";
// Import default images for fallback
// import defaultPropertyImage from "../assets/default-property.webp";
import success_popup_img from "../assets/success_popup_img.webp";
import MarketDetailSkeleton from "./MarketDetailSkeleton";

const MarketDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Web3Modal hooks
  const { open } = useWeb3Modal();
  const { isConnected, address, chainId } = useWeb3ModalAccount();
  const { walletProvider } = useWeb3ModalProvider();

  // State
  const [propertyDetail, setPropertyDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [buyLoading, setBuyLoading] = useState(false);
  const [tokensToBuy, setTokensToBuy] = useState(1);
  const [relatedAssets, setRelatedAssets] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("");

  const [stockSymbol, setStockSymbol] = useState("null"); // 👈 store stock symbol

  // ✅ Hook must be at top-level
  const livePrice = useLiveStockPrice(stockSymbol);

  console.log(livePrice, "livePrice");
  // Fetch property details
  const getPropertyDetails = async (propertyId) => {
    try {
      setLoading(true);
      const data = {
        apiUrl: apiService.getTokenById,
        payload: { propertyId },
      };

      const resp = await postMethod(data);

      if (resp.status === true) {
        setPropertyDetail(resp.data);
        // Fetch related assets
        // await getRelatedAssets(resp.data.assetType);

        if (resp.data.assetType === "Stocks") {
          // ✅ Save stock symbol to state (fundName = e.g. "AAPL")
          setStockSymbol(resp.data.fundName);
        }

        //
      } else {
        toast.error("Failed to fetch property details");
      }
    } catch (error) {
      console.error("Failed to fetch property details:", error);
      toast.error("Error loading property details");
    } finally {
      setLoading(false);
    }
  };

  const approveStablecoin = async (
    stablecoinAddress,
    spenderAddress,
    amount,
    signer
  ) => {
    try {
      const stablecoin = new ethers.Contract(
        stablecoinAddress,
        BEP20_ABI,
        signer
      );
      const owner = await signer.getAddress();
      const allowance = await stablecoin.allowance(owner, spenderAddress);

      if (BigInt(allowance) >= BigInt(amount)) {
        console.log("✅ Already approved sufficient allowance");
        return { success: true, alreadyApproved: true };
      }

      const tx = await stablecoin.approve(spenderAddress, amount);
      const receipt = await tx.wait();

      console.log("✅ Approval successful:", receipt.transactionHash);
      return { success: true, transactionHash: receipt.transactionHash };
    } catch (err) {
      console.error("❌ BEP20 Approval failed:", err);
      throw err;
    }
  };

  // Buy property tokens function
  // const buyPropertyToken = async (saleAddress, amountToBuy) => {
  //   try {
  //     if (!walletProvider) {
  //       throw new Error("Wallet provider not available");
  //     }

  //     const provider = new BrowserProvider(walletProvider);
  //     const signer = await provider.getSigner();
  //     const userAddress = await signer.getAddress();

  //     const saleContract = new ethers.Contract(
  //       saleAddress,
  //       TokenSaleAbi,
  //       signer
  //     );
  //     const price = await saleContract.tokenPrice();
  //     const stablecoinAddress = await saleContract.stablecoin();

  //     const totalCost = BigInt(price) * BigInt(amountToBuy);

  //     // Check if using stablecoin or native token
  //     if (stablecoinAddress !== ethers.ZeroAddress) {
  //       // Using stablecoin
  //       const bep20Token = new ethers.Contract(
  //         stablecoinAddress,
  //         BEP20_ABI,
  //         signer
  //       );
  //       const balance = await bep20Token.balanceOf(userAddress);

  //       if (BigInt(balance) < totalCost) {
  //         throw new Error("Insufficient stablecoin balance");
  //       }

  //       // Approve first
  //       await approveStablecoin(
  //         stablecoinAddress,
  //         saleAddress,
  //         totalCost,
  //         signer
  //       );
  //     } else {
  //       // Using native token
  //       const balance = await provider.getBalance(userAddress);
  //       if (BigInt(balance) < totalCost) {
  //         throw new Error("Insufficient native token balance");
  //       }
  //     }

  //     // Buy property tokens
  //     const tx = await saleContract.buy(BigInt(amountToBuy));

  //     console.log(tx, "tx");
  //     const receipt = await tx.wait();

  //     console.log(receipt, "treceipt");

  //     console.log("✅ Token purchase successful:", receipt.hash);
  //     return {
  //       success: true,
  //       transactionHash: receipt.hash,
  //       blockNumber: receipt.blockNumber,
  //     };
  //   } catch (err) {
  //     console.error("❌ Buy failed:", err);
  //     return { success: false, message: err.message || "Unknown error" };
  //   }
  // };

  const buyPropertyToken = async (saleAddress, amountToBuy) => {
  try {
    if (!walletProvider) {
      throw new Error("Wallet provider not available");
    }

    // Create provider & signer (same as buyPropertyToken)
    const provider = new BrowserProvider(walletProvider);
    const signer = await provider.getSigner();
    const userAddress = await signer.getAddress();

    // let message = "Purchase Token "+amountToBuy;

    const message = `
      Property Purchase Authorization

      Wallet: ${userAddress}
      Amount of token: ${amountToBuy}
      Timestamp: ${Date.now()}
      `;

    // Sign message
    const signature = await signer.signMessage(message);

    console.log("✅ Message signed");
    console.log("User:", userAddress);
    console.log("Message:", message);
    console.log("Signature:", signature);

    return {
      success: true,
      address: userAddress,
      message,
      signature,
    };
  } catch (err) {
    console.error("❌ Message signing failed:", err);
    return {
      success: false,
      message: err.message || "Unknown error",
    };
  }
};

  // Handle form submission
  const handleInvest = async () => {
    if (!propertyDetail) {
      toast.error("Property details not loaded");
      return;
    }

    if (!isConnected) {
      toast.info("Please connect your wallet first");
      await open();
      return;
    }

    if (tokensToBuy <= 0 || isNaN(tokensToBuy)) {
      toast.error("Please enter a valid number of tokens");
      return;
    }

    if (tokensToBuy > propertyDetail.availableTokens) {
      toast.error(`Maximum ${propertyDetail.availableTokens} tokens available`);
      return;
    }

    try {
      setBuyLoading(true);

      // Buy tokens
      const result = await buyPropertyToken(
        propertyDetail.SaleAddress,
        tokensToBuy
      );

      if (result.success) {
        // Record purchase in backend
        await recordPurchase(result.transactionHash, tokensToBuy);

        // Show success modal
        document.getElementById("successfullyPopup").classList.add("show");
      } else {
        toast.error(result.message || "Purchase failed");
      }
    } catch (error) {
      console.error("Investment failed:", error);
      toast.error(error.message || "Investment failed");
    } finally {
      setBuyLoading(false);
    }
  };

  // Record purchase in backend
  const recordPurchase = async (transactionHash, tokenAmount) => {
    try {
      const purchaseData = {
        propertyId: propertyDetail._id,
        walletAddress: address,
        tokensToBuy: tokenAmount,
        amountPaid: tokenAmount * propertyDetail.tokenPrice,
        tokenPrice: propertyDetail.tokenPrice,
        transactionHash: transactionHash,
      };

      const response = await postMethod({
        apiUrl: apiService.buyTokens,
        payload: purchaseData,
      });

      if (response.status === true) {
        toast.success("Purchase recorded successfully!");
        navigate("/portfolio");
      } else {
        toast.error("Purchase completed but failed to record in database");
      }
    } catch (error) {
      console.error("Backend recording failed:", error);
      toast.error("Purchase completed but failed to record in database");
    }
  };

  const calculateTotalCost = () => {
    return tokensToBuy * (livePrice ?? propertyDetail.tokenPrice);
  };

  const calculateTokensReceived = () => {
    return tokensToBuy;
  };

  const handlePaymentMethodSelect = (method) => {
    setPaymentMethod(method);
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  // Get asset-specific details
  const getAssetSpecificDetails = () => {
    if (!propertyDetail) return [];

    const details = [];

    // Common details
    details.push({ label: "Asset Type", value: propertyDetail.assetType });
    details.push({
      label: "Geographic Focus",
      value: propertyDetail.geographicFocus || "Global",
    });

    // Asset-specific details
    if (propertyDetail.assetType === "Real Estate") {
      if (propertyDetail.propertyType)
        details.push({
          label: "Property Type",
          value: propertyDetail.propertyType,
        });
      if (propertyDetail.yearBuilt)
        details.push({ label: "Year Built", value: propertyDetail.yearBuilt });
      if (propertyDetail.floors)
        details.push({ label: "Floors", value: propertyDetail.floors });
      if (propertyDetail.totalArea)
        details.push({ label: "Total Area", value: propertyDetail.totalArea });
      if (propertyDetail.leaseExpiry)
        details.push({
          label: "Lease Expiry",
          value: formatDate(propertyDetail.leaseExpiry),
        });
    }

    if (
      propertyDetail.assetType === "Treasuries & Bonds" ||
      propertyDetail.assetType === "Private Credit"
    ) {
      if (propertyDetail.issuer)
        details.push({ label: "Issuer", value: propertyDetail.issuer });
      if (propertyDetail.interestRate)
        details.push({
          label: "Interest Rate",
          value: propertyDetail.interestRate,
        });
      if (propertyDetail.maturityDate)
        details.push({
          label: "Maturity Date",
          value: formatDate(propertyDetail.maturityDate),
        });
    }

    return details;
  };

  useEffect(() => {
    if (id) {
      getPropertyDetails(id);
    }
  }, [id]);

  if (!propertyDetail) {
    return (
      <>
        <Header />
        <main className="main_flx">
          <Sidebar />
          <div className="right_wrap market_wrap_main market_Detail_main">
            <div className="error-message">Property not found</div>
          </div>
        </main>
      </>
    );
  }

  const assetSpecificDetails = getAssetSpecificDetails();

  return (
    <>
      <Header />

      <main className="main_flx">
        <Sidebar />

        {loading ? (
          // <div className="loading-overlay">
          //   <Oval
          //     color="#292B2C"
          //     secondaryColor="#D9D9D9"
          //     strokeWidth={2}
          //     height={75}
          //     width={75}
          //   />
          // </div>
          <MarketDetailSkeleton />
        ) : (
          <>
            <div className="right_wrap market_wrap_main market_Detail_main">
              <div className="market_Detail_wrp">
                <Link to={"/market"} className="page_back_common">
                  <FaChevronLeft />
                  <span>Back to Market</span>
                </Link>

                <div className="market_details_card">
                  <div className="mrkt_detl_mai_crd">
                    {/* Left Side - Property Details */}
                    <div className="detl_crd_one mrk_lft_sidecrd">
                      <div className="mrkt_top_title">
                        <div className="img_div">
                          <img
                            src={
                              propertyDetail.profileImage ||
                              defaultPropertyImage
                            }
                            alt={propertyDetail.fundName}
                            onError={(e) => {
                              e.target.src = defaultPropertyImage;
                            }}
                          />
                        </div>
                        <h6>{propertyDetail.fundName}</h6>
                        {propertyDetail.status === "active" && (
                          <span className="mrkt_sts">Active</span>
                        )}
                      </div>

                      <div className="mrktcard_main_img">
                        <img
                          src={
                            propertyDetail.profileImage || defaultPropertyImage
                          }
                          alt={propertyDetail.fundName}
                          onError={(e) => {
                            e.target.src = defaultPropertyImage;
                          }}
                        />
                      </div>

                      <div className="mrkt_main_cd_tlt">
                        <h3>{propertyDetail.fundName}</h3>
                        <h5>
                          {propertyDetail.investmentStrategy ||
                            propertyDetail.assetClass}
                        </h5>
                        <p>{propertyDetail.description}</p>
                      </div>

                      <ul className="mrkt_crd_list">
                        <li>
                          <h6>Asset Class</h6>
                          <p>{propertyDetail.assetClass}</p>
                        </li>
                        <li>
                          <h6>Target Returns</h6>
                          <p>{propertyDetail.targetReturns}</p>
                        </li>
                        <li>
                          <h6>Fund Term</h6>
                          <p>{propertyDetail.fundTerm}</p>
                        </li>
                        <li>
                          <h6>Min Investment</h6>
                          <p>
                            USD {propertyDetail.minInvestment?.toLocaleString()}
                          </p>
                        </li>
                      </ul>

                      {/* Asset Specific Details */}
                      {assetSpecificDetails.length > 0 && (
                        <div className="prpty_inform_wrp">
                          <h6>Asset Information</h6>
                          <ul>
                            {assetSpecificDetails.map((detail, index) => (
                              <li key={index}>
                                <span>{detail.label}</span>
                                <span>{detail.value}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      <div className="mrk_button_cdone">
                        <button
                          className="Cancel"
                          onClick={() => navigate("/market")}
                        >
                          Cancel
                        </button>
                        <button
                          className="mrkt_common_btn invest_now"
                          onClick={() =>
                            document
                              .getElementById("investmentSection")
                              .scrollIntoView({ behavior: "smooth" })
                          }
                        >
                          Invest Now
                        </button>
                      </div>
                    </div>

                    {/* Right Side - Investment Section */}
                    <div className="mrk_rgt_side_wrp">
                      <div
                        className="detl_crd_two mrk_rgt_sidecrd"
                        id="investmentSection"
                      >
                        <div className="selct_infr_wrp">
                          <div className="infrm_cont_main">
                            <p>Selected Asset</p>
                            <span>{propertyDetail.fundName}</span>
                          </div>
                          <div className="infrm_cont_main">
                            <p>Token Price</p>
                            <span>
                              $ {livePrice ?? propertyDetail.tokenPrice}
                            </span>
                          </div>
                          <div className="infrm_cont_main">
                            <p>Available Tokens</p>
                            <span>
                              {propertyDetail.availableTokens?.toLocaleString()}
                            </span>
                          </div>
                        </div>

                        <div className="money_input_wrp money_input_wrpnew">
                          <label>Number of Tokens to Buy</label>
                          <div className="money_input_main">
                            <input
                              placeholder="Enter number of tokens"
                              type="number"
                              value={tokensToBuy}
                              onChange={(e) => {
                                const value = parseInt(e.target.value);
                                if (!isNaN(value) && value >= 0) {
                                  setTokensToBuy(
                                    Math.min(
                                      value,
                                      propertyDetail.availableTokens
                                    )
                                  );
                                }
                              }}
                              min="1"
                              max={propertyDetail.availableTokens}
                            />
                          </div>
                          <span>
                            Min: 1, Max:{" "}
                            {propertyDetail.availableTokens?.toLocaleString()}
                          </span>
                        </div>

                        <div className="amount_details_mrkt">
                          <div className="amount_details_item">
                            <h6>You will receive</h6>
                            <p>
                              <span>
                                {calculateTokensReceived().toLocaleString()}
                              </span>{" "}
                              tokens
                            </p>
                          </div>
                          <div className="amount_details_item">
                            <h6>Total Cost</h6>
                            <p>${calculateTotalCost().toLocaleString()}</p>
                          </div>
                          <div className="amount_details_item">
                            <h6>Estimated Returns</h6>
                            <p>
                              <span>+{propertyDetail.targetReturns}</span>
                            </p>
                          </div>
                        </div>

                        <p className="amount_not_mrkt">
                          Investment amount: $
                          {calculateTotalCost().toLocaleString()}
                        </p>

                        <button
                          // onClick={}
                          onClick={() => {
                            handleInvest();
                          }}
                          disabled={buyLoading}
                          className="money_send_btn mrkt_common_btn"
                        >
                          {buyLoading ? "Processing..." : "Confirm Invest"}
                        </button>

                        {!isConnected && (
                          <p className="wallet-connect-note text-white mt-2">
                            You'll need to connect your wallet to complete the
                            purchase
                          </p>
                        )}
                      </div>

                      {/* Details Tabs */}
                      <div className="mrkt_detlTab_wrp mrk_rgt_sidecrd">
                        <h5 className="mrkt_bottm_title">Details</h5>
                        <div className="mrkt_dtl_tab_main">
                          <ul
                            className="nav nav-pills mb-3 mrkt_dtl_tab_ul"
                            role="tablist"
                          >
                            <li className="nav-item">
                              <button
                                className="nav-link active"
                                data-bs-toggle="pill"
                                data-bs-target="#overview"
                              >
                                Overview
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                className="nav-link"
                                data-bs-toggle="pill"
                                data-bs-target="#financials"
                              >
                                Financials
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                className="nav-link"
                                data-bs-toggle="pill"
                                data-bs-target="#compliance"
                              >
                                Compliance
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                className="nav-link"
                                data-bs-toggle="pill"
                                data-bs-target="#documents"
                              >
                                Documents
                              </button>
                            </li>
                          </ul>

                          <div className="tab-content">
                            <div
                              className="tab-pane fade show active"
                              id="overview"
                            >
                              <div className="mrkt_dtl_content">
                                <h4 className="mrkt_dtl_title">Overview</h4>
                                <p className="mrkt_dtl_description">
                                  {propertyDetail.description}
                                </p>
                              </div>
                              <ul className="mrkt_dtl_ul">
                                <li>
                                  <h4 className="mrkt_dtl_title">
                                    Investment Strategy
                                  </h4>
                                  <p className="mrkt_dtl_description">
                                    {propertyDetail.investmentStrategy}
                                  </p>
                                </li>
                                <li>
                                  <h4 className="mrkt_dtl_title">
                                    Geographic Focus
                                  </h4>
                                  <p className="mrkt_dtl_description">
                                    {propertyDetail.geographicFocus || "Global"}
                                  </p>
                                </li>
                              </ul>
                            </div>

                            <div className="tab-pane fade" id="financials">
                              <div className="mrkt_dtl_content">
                                <h4 className="mrkt_dtl_title">
                                  Financial Details
                                </h4>
                              </div>
                              <ul className="mrkt_dtl_ul">
                                <li>
                                  <h4 className="mrkt_dtl_title">
                                    Target Returns
                                  </h4>
                                  <p className="mrkt_dtl_description">
                                    {propertyDetail.targetReturns}
                                  </p>
                                </li>
                                <li>
                                  <h4 className="mrkt_dtl_title">
                                    Minimum Investment
                                  </h4>
                                  <p className="mrkt_dtl_description">
                                    USD{" "}
                                    {propertyDetail.minInvestment?.toLocaleString()}
                                  </p>
                                </li>
                                <li>
                                  <h4 className="mrkt_dtl_title">
                                    Available Tokens
                                  </h4>
                                  <p className="mrkt_dtl_description">
                                    {propertyDetail.availableTokens?.toLocaleString()}
                                  </p>
                                </li>
                              </ul>
                            </div>

                            <div className="tab-pane fade" id="compliance">
                              <div className="mrkt_dtl_content">
                                <h4 className="mrkt_dtl_title">
                                  Legal & Compliance
                                </h4>
                              </div>
                              <ul className="mrkt_dtl_ul">
                                <li>
                                  <h4 className="mrkt_dtl_title">Status</h4>
                                  <p className="mrkt_dtl_description">
                                    {propertyDetail.status}
                                  </p>
                                </li>
                                <li>
                                  <h4 className="mrkt_dtl_title">
                                    KYC Required
                                  </h4>
                                  <p className="mrkt_dtl_description">Yes</p>
                                </li>
                                <li>
                                  <h4 className="mrkt_dtl_title">
                                    Token Address
                                  </h4>
                                  <p className="mrkt_dtl_description view_on_etherscan">
                                    {propertyDetail.TokenAddress
                                      ? `${propertyDetail.TokenAddress.substring(
                                          0,
                                          8
                                        )}...${propertyDetail.TokenAddress.substring(
                                          propertyDetail.TokenAddress.length - 6
                                        )}`
                                      : "Not deployed"}
                                  </p>
                                </li>
                              </ul>
                            </div>

                            <div className="tab-pane fade" id="documents">
                              <div className="mrkt_dtl_content">
                                <h4 className="mrkt_dtl_title">Documents</h4>
                              </div>
                              <ul className="mrkt_dtl_ul">
                                <li>
                                  <h4 className="mrkt_dtl_title">
                                    Whitepaper / Investment Thesis
                                  </h4>
                                  {propertyDetail.whitepaperDoc ? (
                                    <a
                                      href={propertyDetail.whitepaperDoc}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View Document
                                    </a>
                                  ) : (
                                    <p className="mrkt_dtl_description">
                                      Not available
                                    </p>
                                  )}
                                </li>
                                <li>
                                  <h4 className="mrkt_dtl_title">
                                    Property Valuation Report
                                  </h4>
                                  {propertyDetail.valuationDoc ? (
                                    <a
                                      href={propertyDetail.valuationDoc}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View Document
                                    </a>
                                  ) : (
                                    <p className="mrkt_dtl_description">
                                      Not available
                                    </p>
                                  )}
                                </li>
                                <li>
                                  <h4 className="mrkt_dtl_title">
                                    Legal Disclosures
                                  </h4>
                                  {propertyDetail.legalDoc ? (
                                    <a
                                      href={propertyDetail.legalDoc}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View Document
                                    </a>
                                  ) : (
                                    <p className="mrkt_dtl_description">
                                      Not available
                                    </p>
                                  )}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-5">
                <Footer />
              </div>
            </div>

            <div
              className="modal fade successfull_popup common_popup_main"
              id="successfullyPopup"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <img
                      className="success_popup_img"
                      src={success_popup_img}
                      alt="Success"
                    />
                    <h5 className="modal-title">
                      You have successfully <br /> invested in{" "}
                      {propertyDetail?.fundName}.
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() =>
                        document
                          .getElementById("successfullyPopup")
                          .classList.remove("show")
                      }
                    >
                      <IoIosCloseCircle />
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="successfull_wrp_popup">
                      <div className="successfull_content">
                        <ul>
                          <li>
                            <h4>Amount Invested</h4>
                            <span>-</span>
                            <h6>
                              ${calculateTotalCost().toLocaleString()} (
                              {tokensToBuy} tokens)
                            </h6>
                          </li>
                          <li>
                            <h4>Asset Name</h4>
                            <span>-</span>
                            <h6>{propertyDetail?.fundName}</h6>
                          </li>
                          <li>
                            <h4>Ownership Type</h4>
                            <span>-</span>
                            <h6>Fractional (Tokenized Units)</h6>
                          </li>
                          <li>
                            <h4>Est. Annual Yield</h4>
                            <span>-</span>
                            <h6>{propertyDetail?.targetReturns}</h6>
                          </li>
                          <li>
                            <h4>Transaction Hash</h4>
                            <span>-</span>
                            <h6 className="trnsnumber_id">0x9f3…d81a</h6>
                          </li>
                        </ul>
                      </div>
                      <div className="succfl_btn_wrp">
                        <button
                          className="successfull_fotm_btn"
                          onClick={() => navigate("/portfolio")}
                        >
                          Go to Portfolio
                        </button>
                        <button
                          className="invset_fotm_btn"
                          onClick={() =>
                            document
                              .getElementById("successfullyPopup")
                              .classList.remove("show")
                          }
                        >
                          Invest more
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </main>
    </>
  );
};

export default MarketDetails;
